<template>
  <el-container>
    <el-main>
      <h3 class="heading">Details</h3>
      <el-card v-if="item">
        <FlatDealInfo :id="id" v-model="item" />
      </el-card>
      <LoadingBlock :loading="loading" />
      <div v-if="!loading && !item" class="el-alert el-alert--warning is-light">
        <h4>
          Unfortunately, this deal was sold or deactivated by the publisher, but
          you can find more deals in
          <router-link to="/direct_deals">
            <el-button type="text"> the deal buffet </el-button>
          </router-link>
        </h4>
      </div>
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { ref, defineComponent, computed, watch, onMounted } from 'vue'

import FlatDealInfo from '../components/FlatDealInfo.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import { removeLocalStorageKey } from '@/utils/helpers'
import { useCountriesStore } from '@/store/modules/countries'
import { useFlatDealsStore } from '@/apps/traforama/store/flatDeals'

export default defineComponent({
  name: 'ShowFlatDeal',
  components: {
    FlatDealInfo,
    LoadingBlock
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  setup(props) {
    useCountriesStore().GetItems()
    removeLocalStorageKey('flat_deal_id')
    removeLocalStorageKey('media_kit_id')

    const flatDealsStore = useFlatDealsStore()
    const item = computed(() => flatDealsStore.current)
    const loading = computed(() => flatDealsStore.itemsLoading[props.id])

    watch(
      () => props.id,
      (newVal) => {
        flatDealsStore.FetchItem(newVal)
      }
    )

    onMounted(() => flatDealsStore.FetchItem(props.id))

    return { item, loading }
  }
})
</script>
<style lang="scss" scoped>
.filter-container {
  padding-bottom: 0;
  .el-card__body {
    padding-bottom: 0;
  }
}

.padding-5 {
  padding-top: 5px;
  padding-bottom: 5px;
}

:deep(.el-card.is-always-shadow) {
  box-shadow: none;
}
</style>
